import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "td__use-yn" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "td__rest-days ta-c" };
const _hoisted_6 = { class: "td__working-time" };
const _hoisted_7 = { class: "td__phone" };
const _hoisted_8 = ["title"];
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "td__store-code" };
const _hoisted_11 = { class: "td__vat-rate ta-c" };
const _hoisted_12 = { class: "td__delivery-pay-flag ta-c" };
const _hoisted_13 = { class: "td__delivery-detail ta-c" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { class: "td__deposit-baromoney" };
const _hoisted_16 = { class: "td__baromoney" };
const _hoisted_17 = { class: "td__created-at" };
import { computed, toRefs, } from 'vue';
import { routeName } from '@/constants/routeName';
import { storeStatusOptionList } from '@/constants/storeManagement';
import { makeItemToComputed } from '@/utils/vueUtils';
import { useRouter } from 'vue-router';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: { default: () => { } }
    },
    setup(__props) {
        const props = __props;
        const { item } = toRefs(props);
        const router = useRouter();
        const getterSearchField = computed(() => vuexStore.getters['storeManagement/storeList/getterSearchField']);
        const getterSearchValue = computed(() => vuexStore.getters['storeManagement/storeList/getterSearchValue']);
        const getterStoreStatusType = computed(() => vuexStore.getters['storeManagement/storeList/getterStoreStatusType']);
        const getterDeliveryPayFlagType = computed(() => vuexStore.getters['storeManagement/storeList/getterDeliveryPayFlagType']);
        const getterPageSizeType = computed(() => vuexStore.getters['storeManagement/storeList/getterPageSizeType']);
        const storeStatusImgPath = computed(() => {
            const [storeStatus,] = storeStatusOptionList
                .filter((option) => option.value === item.value.useYn);
            return `/svg/use-yn-${storeStatus.imgIcon}.svg`;
        });
        const validatedStoreName = makeItemToComputed(item, 'validatedStoreName');
        const validatedHubName = makeItemToComputed(item, 'validatedHubName');
        const validatedRestDays = makeItemToComputed(item, 'validatedRestDays');
        const formattedWorkingTime = makeItemToComputed(item, 'formattedWorkingTime');
        const formattedPhone = makeItemToComputed(item, 'formattedPhone');
        const validatedCeoName = makeItemToComputed(item, 'validatedCeoName');
        const formattedShortenAddress = makeItemToComputed(item, 'formattedShortenAddress');
        const validatedStoreCode = makeItemToComputed(item, 'validatedStoreCode');
        const formattedVatRate = makeItemToComputed(item, 'formattedVatRate');
        const formattedDeliveryPayFlag = makeItemToComputed(item, 'formattedDeliveryPayFlag');
        const validatedDeliveryDetail = makeItemToComputed(item, 'validatedDeliveryDetail');
        const formattedDepositBaromoney = makeItemToComputed(item, 'formattedDepositBaromoney');
        const formattedBaromoney = makeItemToComputed(item, 'formattedBaromoney');
        const formattedCreatedAt = makeItemToComputed(item, 'formattedCreatedAt');
        const isLastDeliveryDetailInfo = (key) => key === item.value
            .validatedDeliveryDetail.length - 1;
        const handleClickStoreName = (storeId) => {
            router.push({
                name: routeName.STORE_MANAGEMENT_DETAIL,
                params: {
                    storeId,
                },
                query: {
                    searchField: getterSearchField.value,
                    searchValue: getterSearchValue.value,
                    storeStatusType: getterStoreStatusType.value,
                    deliveryPayFlagType: getterDeliveryPayFlagType.value,
                    pageSizeType: getterPageSizeType.value,
                },
            }).catch(() => { });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("img", { src: storeStatusImgPath.value }, null, 8 /* PROPS */, _hoisted_2)
                ]),
                _createCommentVNode(" TODO 구분 api name 확인하기\n    <td\n      class=\"td__section\"\n    >\n      {{ section }}\n    </td>\n "),
                _createElementVNode("td", {
                    class: "td__hub-name",
                    title: _unref(validatedHubName)
                }, _toDisplayString(_unref(validatedHubName)), 9 /* TEXT, PROPS */, _hoisted_3),
                _createElementVNode("td", {
                    class: "td__store-name",
                    title: _unref(validatedStoreName),
                    onClick: _cache[0] || (_cache[0] = ($event) => (handleClickStoreName(_unref(item).code)))
                }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(validatedStoreName)), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_4),
                _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(validatedRestDays)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formattedWorkingTime)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formattedPhone)), 1 /* TEXT */),
                _createElementVNode("td", {
                    class: "td__ceo-name",
                    title: _unref(validatedCeoName)
                }, _toDisplayString(_unref(validatedCeoName)), 9 /* TEXT, PROPS */, _hoisted_8),
                _createElementVNode("td", {
                    class: "td__address",
                    title: _unref(formattedShortenAddress)
                }, _toDisplayString(_unref(formattedShortenAddress)), 9 /* TEXT, PROPS */, _hoisted_9),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(validatedStoreCode)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formattedVatRate)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formattedDeliveryPayFlag)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(validatedDeliveryDetail), (value, key) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: `${key}_${value}`
                        }, [
                            _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(value) + " ", 1 /* TEXT */),
                                (!isLastDeliveryDetailInfo(key))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " /  "))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formattedDepositBaromoney)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formattedBaromoney)), 1 /* TEXT */),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formattedCreatedAt)), 1 /* TEXT */)
            ]));
        };
    }
});
